import { concatClasses } from "../../../../helpers/concatClasses/index.js";
import { fontMap, tagMap, textColorMap, textDecorationMap } from "./constants.js";
const getTag = ({ dsf_tag_override, dsf_inline, dsf_level }) => {
  if (dsf_tag_override) {
    return tagMap[dsf_tag_override] || tagMap.span;
  }
  if (dsf_inline) {
    return tagMap.span;
  }
  switch (dsf_level) {
    case "jumbo-semibold":
      return tagMap.h1;
    case "xxl-semibold":
      return tagMap.h2;
    case "xl-semibold":
      return tagMap.h3;
    case "l-semibold":
      return tagMap.h4;
    case "m-semibold":
      return tagMap.h5;
    default:
      return tagMap.p;
  }
};
const getColorClasses = ({ dsf_color, dsf_color_intensity, dsf_decoration }) => {
  const color = dsf_color;
  const intensity = dsf_color_intensity || (!dsf_color || dsf_color === "neutral" ? 700 : 300);
  const colorKey = `${color}_${intensity}`;
  const classes = [textColorMap[colorKey]];
  if (dsf_decoration) {
    classes.push(textDecorationMap[colorKey]);
  }
  return classes;
};
const getTextClasses = (props, isInline = false) => {
  const classes = [
    fontMap[props.dsf_level || "s"],
    isInline ? "inline" : "block",
    ...getColorClasses(props)
  ];
  switch (props.dsf_decoration) {
    case "line-through":
      classes.push("line-through");
      break;
    case "overline":
      classes.push("overline");
      break;
    case "underline":
      classes.push("underline");
      break;
  }
  return concatClasses(classes);
};
const displayVariable = "--dsf-text-display";
const updateCSSVariables = (comp) => {
  if (comp.dsf_inline) {
    comp.style.setProperty(displayVariable, "inline");
  }
};
export {
  displayVariable,
  getColorClasses,
  getTag,
  getTextClasses,
  updateCSSVariables
};
